import React from 'react';
import { Anchor } from 'Components';
import { Icons } from 'Assets';
import { Link } from 'Components/Link/Link';

export const Footer: React.FC = () => (
  <div
    data-testid="footer"
    className="flex flex-col items-center border-whitesmoke border-t-[1px] text-sm px-4 text-dark-gray bg-white [&>*]:md:max-w-full [&>*]:md:w-[980px]"
  >
    <span className="py-3 md:text-center">
      Besoin de nous{' '}
      <Link
        href="https://www.darty.com/achat/contacts/chat-service-client/index.html"
        ariaLabel="Contacter un conseiller Darty"
        openInNewTab
        type="modal"
        classNames="!text-dark-gray"
      >
        contacter
      </Link>{' '}
      ? Nous sommes là pour vous aider.
    </span>

    <div className="w-full flex flex-col items-center gap-2 border-whitesmoke border-t-[1px] py-3 md:flex-row md:justify-center">
      <Anchor href="https://www.acce-o.fr/client/darty/" target="_blank">
        Accessible sourds et malentendants
      </Anchor>

      <span className="hidden md:block">-</span>

      <button className="ot-sdk-show-settings text-navy-blue hover:underline hover:cursor-pointer">Gérer mes cookies</button>
    </div>

    <span className="w-full flex justify-center gap-2 border-whitesmoke border-t-[1px] text-center py-3 text-xs">
      <img src={Icons.Lock} alt="cadenas fermé" />
      <span className="uppercase">Paiement sécurisé</span>
    </span>
  </div>
);
